<template>
<div class="PurchasingTypeList">
</div>
</template>

<script>
export default {
    name: 'PurchasingTypeList',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.PurchasingTypeList {
}
</style>
